import axios from 'axios';
import {NavigateFunction} from 'react-router-dom';

import {FetchCountryName} from './CountryUtility';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

type TopicType = 'sightseeing' | 'food';

interface CursorItem {
  id: number | string;
  iso: string;
}

interface NavigateWithCursorParams {
  item: CursorItem | null | undefined;
  navigate: NavigateFunction;
  topic: TopicType;
  pageSize?: number;
  category?: string;
}

export async function navigateToTopicWithCursor({
  item,
  navigate,
  topic,
  pageSize = 9,
  category = '',
}: NavigateWithCursorParams): Promise<void> {
  if (!item) {
    return;
  }

  try {
    const countryName = await FetchCountryName(item.iso);
    const cursorResponse = await axios.get(
        `${backendUrl}/worlddata/${topic}/get-cursor-for-item/${item.id}/${pageSize}/?iso=${item.iso}`,
    );
    const cursor = cursorResponse.data.cursor;
    const cursorToken = cursorResponse.data.cursor_token || '';

    navigate(`/traveltopics/${countryName}/topics/${topic}`, {
      state: {
        selectedItemId: item.id,
        selectedItemCursor: cursor,
        selectedItemCursorToken: cursorToken,
        category,
      },
    });
  } catch (error) {
    console.error(`Error navigating to ${topic} item:`, error);
  }
}

interface NavigateToSightseeingParams {
  item: CursorItem | null | undefined;
  navigate: NavigateFunction;
  pageSize?: number;
  category?: string;
}

export async function navigateToSightseeingWithCursor({
  item,
  navigate,
  pageSize,
  category,
}: NavigateToSightseeingParams): Promise<void> {
  return navigateToTopicWithCursor({
    item,
    navigate,
    topic: 'sightseeing',
    pageSize,
    category,
  });
}

interface NavigateToFoodParams {
  item: CursorItem | null | undefined;
  navigate: NavigateFunction;
  pageSize?: number;
  category?: string;
}

export async function navigateToFoodWithCursor({
  item,
  navigate,
  pageSize,
  category,
}: NavigateToFoodParams): Promise<void> {
  return navigateToTopicWithCursor({
    item,
    navigate,
    topic: 'food',
    pageSize,
    category,
  });
}